export const GET_NEW_USERS = 'GET_NEW_USERS';
export const GET_TOTAL_USER_COUNT = 'GET_TOTAL_USER_COUNT';
export const GET_CURRENT_PAGE = 'GET_CURRENT_PAGE';
export const GET_ADMIN_SUMMARY = 'GET_ADMIN_SUMMARY';

